"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logError = logError;

var _logger = require("@insided/shared/services/logger");

/** Log error to console and forward to NewRelic browser agent when available. */
function logError(error) {
  _logger.logger.error(error);
}